<div class="row reason-row">
    <div>
        <p class="tiny tiny-title">Motivo de la desaprobación</p>
        <span class="reason">{{ (entity.rejectionReason | capitalizeOnlyFirstLetter) }}</span>
    </div>
</div>